import React from 'react';
import ReactDOM from 'react-dom/client';

import './config/ReactotronConfig';
import './assets/scss/paper-dashboard.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
